import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isMobile from 'ismobilejs';
import PopularCategories from '../../../styled/search/popular-categories';
import Autosuggest from 'react-autosuggest';

import axios from 'axios';

const focusInputOnSuggestionClick = !isMobile.any;
const SUGGESTION_URL = 'https://cerebro.k8s.hipages.com.au/suggest/'; //todo need to set this up for production
const SUGGESTION_SIZE = 5; //max number of results to show for each section in autosuggest
const getSuggestionValue = suggestion => suggestion.name;

export function makeTheme(prefix) {
  return {
    container: `${prefix}__container`,
    containerOpen: `${prefix}__container--open`,
    input: `${prefix}__input`,
    inputOpen: `${prefix}__input--open`,
    inputFocused: `${prefix}__input--focused`,
    suggestionsContainer: `${prefix}__suggestions-container`,
    suggestionsContainerOpen: `${prefix}__suggestions-container--open`,
    suggestionsList: `${prefix}__suggestions-list`,
    suggestion: `${prefix}__suggestion`,
    suggestionFirst: `${prefix}__suggestion--first`,
    suggestionHighlighted: `${prefix}__suggestion--highlighted`,
    sectionContainer: `${prefix}__section-container`,
    sectionContainerFirst: `${prefix}__section-container--first`,
    sectionTitle: `${prefix}__section-title`
  };
}

const dedupeCategoryNames = suggestions => {
  const names = new Set();
  return suggestions.reduce((suggestions, suggestion) => {
    if (suggestion.site_key) {
      return [...suggestions, suggestion];
    }
    if (names.has(suggestion.practice_person_plural)) {
      return [...suggestions];
    }
    names.add(suggestion.practice_person_plural);
    return [...suggestions, { ...suggestion, displayName: suggestion.practice_person_plural }];
  }, []);
};

const NO_RESULTS = Symbol();

const mapPrefixToSelector = {
  'Let us find you ': 'single-search-category-postjob-suggestion',
  'Browse ': 'single-search-category-tradies-suggestion'
};

const renderSuggestion = classPrefix => suggestion => {
  if (suggestion === NO_RESULTS) {
    return false;
  }
  //if this is a post a job/category result
  if (suggestion.practice_id) {
    return (
      <div
        className={`${classPrefix}__suggestion__text`}
        data-label={mapPrefixToSelector[suggestion.prefix_text] || false}
      >
        {/* if we have prefix text available, show the prefix in regular and category name in bold */}
        {suggestion.prefix_text ? (
          <div>
            {suggestion.prefix_text}
            <span>{suggestion.displayName}</span>
          </div>
        ) : (
          suggestion.displayName
        )}
      </div>
    );
  }

  return (
    <a href={suggestion.directory_url} data-label={'single-search-category-business-suggestion'}>
      {/* show thumbnail if there is one available */}
      {suggestion.thumbnail ? (
        <div
          className={`${classPrefix}__suggestion__thumbnail`}
          style={{ backgroundImage: `url(${suggestion.thumbnail})` }}
        />
      ) : (
        ''
      )}

      <div className={`${classPrefix}__suggestion__text__business-name`}>
        {/* if we have prefix text available, show the prefix in regular and category name in bold */}
        {suggestion.prefix_text ? (
          <div>
            {suggestion.prefix_text}
            <span>{suggestion.name}</span>
          </div>
        ) : (
          suggestion.name
        )}

        {/* show location if there is one available */}
        {suggestion.site_region_name && suggestion.contact_suburb ? (
          <div className={`${classPrefix}__suggestion__text__location`}>
            {suggestion.contact_suburb}, {suggestion.site_region_name}
          </div>
        ) : (
          ''
        )}
      </div>
    </a>
  );
};

const renderSuggestionContainer = ({ containerProps, children, query }) => (
  <div {...containerProps}>{query ? children : <PopularCategories />}</div>
);

const mapTitleToSelector = {
  'Post a job': 'single-search-postjob-title',
  Tradies: 'single-search-tradies-title',
  Businesses: 'single-search-businesses-title'
};

const renderSectionTitle = section =>
  section.title === 'Popular Categories' ? (
    false
  ) : (
    <div data-label={mapTitleToSelector[section.title] || false}>
      {/* todo this will break if section titles are changed */}

      {section.title === 'Post a job' ? (
        <svg width="15px" height="14px" viewBox="0 0 15 14" version="1.1">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="search-expand" transform="translate(-190.000000, -339.000000)" fill="#F96F12">
              <g id="expandMenu" transform="translate(172.000000, 326.000000)">
                <g id="Group-9">
                  <g id="Group-489" transform="translate(18.000000, 13.000000)">
                    <path
                      d="M12.2223333,6.72 C12.2223333,7.02968 11.974,7.28 11.6667778,7.28 L11.1112222,7.28 C10.804,7.28 10.5556667,7.02968 10.5556667,6.72 L10.5556667,6.16 L4.44455556,6.16 L4.44455556,6.72 C4.44455556,7.02968 4.19622222,7.28 3.889,7.28 L3.33344444,7.28 C3.02622222,7.28 2.77788889,7.02968 2.77788889,6.72 L2.77788889,6.16 L0.000111111111,6.16 L0.000111111111,12.32 C0.000111111111,13.24792 0.746222222,14 1.66677778,14 L13.3334444,14 C14.254,14 15.0001111,13.24792 15.0001111,12.32 L15.0001111,6.16 L12.2223333,6.16 L12.2223333,6.72 Z"
                      id="Fill-485"
                    />
                    <path
                      d="M11.1112222,2.8 L3.889,2.8 L3.889,1.68 C3.889,1.37088 4.13788889,1.12 4.44455556,1.12 L10.5556667,1.12 C10.8623333,1.12 11.1112222,1.37088 11.1112222,1.68 L11.1112222,2.8 Z M13.3334444,2.8 L12.2223333,2.8 L12.2223333,1.68 C12.2223333,0.75208 11.4762222,0 10.5556667,0 L4.44455556,0 C3.524,0 2.77788889,0.75208 2.77788889,1.68 L2.77788889,2.8 L1.66677778,2.8 C0.746222222,2.8 0.000111111111,3.55208 0.000111111111,4.48 L0.000111111111,5.6 L2.77788889,5.6 L2.77788889,5.04 C2.77788889,4.73032 3.02622222,4.48 3.33344444,4.48 L3.889,4.48 C4.19622222,4.48 4.44455556,4.73032 4.44455556,5.04 L4.44455556,5.6 L10.5556667,5.6 L10.5556667,5.04 C10.5556667,4.73032 10.804,4.48 11.1112222,4.48 L11.6667778,4.48 C11.974,4.48 12.2223333,4.73032 12.2223333,5.04 L12.2223333,5.6 L15.0001111,5.6 L15.0001111,4.48 C15.0001111,3.55208 14.254,2.8 13.3334444,2.8 L13.3334444,2.8 Z"
                      id="Fill-487"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      ) : (
        ''
      )}

      {section.title === 'Tradies' ? (
        <svg width="18px" height="14px" viewBox="0 0 18 14" version="1.1">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g
              id="search-expand"
              transform="translate(-189.000000, -429.000000)"
              fillRule="nonzero"
              fill="#F96F12"
            >
              <g id="expandMenu" transform="translate(172.000000, 326.000000)">
                <g id="Group-9-Copy" transform="translate(0.000000, 90.000000)">
                  <path
                    d="M18.0485802,21.974359 C18.0485802,18.6721538 20.0722436,15.7757692 23.0281644,14.6047949 L23.0281644,20.1457436 C22.6960911,20.6750872 22.5039545,21.3018923 22.5039545,21.974359 L18.0485802,21.974359 Z M33.7727386,21.974359 L29.3180059,21.974359 C29.3180059,21.3019821 29.1258693,20.6751769 28.793796,20.1457436 L28.793796,14.6047949 C31.7497168,15.7756615 33.7733802,18.6719744 33.7728455,21.974359 L33.7727386,21.974359 Z M23.2899663,21.974359 C23.2899663,20.5174256 24.465099,19.334641 25.9110158,19.334641 C27.3576455,19.334641 28.5320653,20.5181436 28.5320653,21.974359 C28.5320653,23.4312923 27.3569327,24.613359 25.9110158,24.613359 C24.4643861,24.613359 23.2899663,23.4305744 23.2899663,21.974359 L23.2899663,21.974359 Z M18.0492931,23.0302462 L22.6683426,23.0302462 C23.1111069,24.4079538 24.3962178,25.4055795 25.9110158,25.4055795 C27.4258139,25.4055795 28.710996,24.4078821 29.1536891,23.0302462 L33.7727386,23.0302462 C34.3526416,23.0302462 34.8218535,23.5035 34.8218535,24.0875333 L34.8218535,25.6678641 C34.8218535,26.2511974 34.3505564,26.7251513 33.7727386,26.7251513 L18.0491149,26.7251513 C17.4692119,26.7251513 17,26.2518974 17,25.6678641 L17,24.0875333 C17,23.5042 17.471297,23.0302462 18.0491149,23.0302462 L18.0492931,23.0302462 Z M28.0079267,14.0558872 L28.0079267,19.2701692 C27.4294139,18.8144333 26.7019287,18.5431026 25.9110158,18.5431026 C25.1208693,18.5431026 24.3926891,18.8144333 23.814105,19.2701692 L23.814105,14.0558872 C23.814105,13.4725538 24.2833168,13 24.8625248,13 L26.9594356,13 C27.5386436,13 28.0078554,13.4725538 28.0078554,14.0558872 L28.0079267,14.0558872 Z"
                    id="Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      ) : (
        ''
      )}

      {section.title === 'Businesses' ? (
        <svg width="18px" height="13px" viewBox="0 0 18 13" version="1.1">
          <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="search-expand" transform="translate(-190.000000, -690.000000)" fill="#F96F12">
              <g id="expandMenu" transform="translate(172.000000, 326.000000)">
                <g id="Group-9-Copy-2" transform="translate(0.000000, 350.000000)">
                  <path
                    d="M20,14 L34,14 C35.1045695,14 36,14.8954305 36,16 L36,25 C36,26.1045695 35.1045695,27 34,27 L20,27 L20,27 C18.8954305,27 18,26.1045695 18,25 L18,16 L18,16 C18,14.8954305 18.8954305,14 20,14 L20,14 Z M27,17 L27,18 L34,18 L34,17 L27,17 Z M27,19 L27,20 L32,20 L32,19 L27,19 Z M27,23 L27,24 L31,24 L31,23 L27,23 Z M27,21 L27,22 L33,22 L33,21 L27,21 Z M21.6953357,22 L21.6953357,20.4886487 C21.6953357,20.3061843 21.8526468,20.1629124 22.0529911,20.1629124 L22.9398334,20.1629124 C23.1401776,20.1629124 23.2974888,20.3061843 23.2974888,20.4886487 L23.2974888,22 L24.2846892,22 C24.6781101,22 25,21.7068373 25,21.3485274 L25,19.2312415 C25,19.1205433 24.949984,19.0098451 24.8642054,18.9314599 L22.7395177,17.0879879 C22.6037231,16.9706707 22.3961113,16.9706707 22.2603167,17.0879879 L20.1359152,18.9380397 C20.0501351,19.0161643 20.0001206,19.1268626 20.0001206,19.2378214 L20.0001206,21.3551073 C19.9928559,21.7067982 20.3147429,21.9999609 20.7081638,21.9999609 L21.6953357,22 Z"
                    id="Combined-Shape"
                  />
                </g>
              </g>
            </g>
          </g>
        </svg>
      ) : (
        ''
      )}

      {section.title}
    </div>
  );

const getSectionSuggestions = section => section.results;

export default class ElasticAutocomplete extends Component {
  static propTypes = {
    classPrefix: PropTypes.string,
    className: PropTypes.string,
    categorySearch: PropTypes.bool,
    renderInputComponent: PropTypes.func,
    onSuggestionSelected: PropTypes.func,
    onChange: PropTypes.func,
    onFocus: PropTypes.func,
    onBlur: PropTypes.func,
    showPopularCategories: PropTypes.bool
  };

  constructor() {
    super();

    this.state = {
      value: '',
      suggestions: []
    };
  }

  componentWillMount() {
    this.setState({ theme: makeTheme(this.props.classPrefix) });
  }
  onChange = (event, { newValue }) => {
    this.setState({
      value: newValue
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    const resultUrl = `${SUGGESTION_URL}fuzzimatch`;
    const noResults = [{ title: 'Popular Categories', results: [NO_RESULTS] }];
    axios.get(resultUrl, { params: { keyword: value, size: SUGGESTION_SIZE } }).then(result => {
      this.setState({
        suggestions: value
          ? result.data.filter(section => section.results.length).map(section => ({
              ...section,
              results: dedupeCategoryNames(section.results)
            }))
          : noResults
      });
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  render() {
    const { value, suggestions } = this.state;
    const {
      renderInputComponent,
      onSuggestionSelected,
      classPrefix,
      className,
      showPopularCategories,
      ...rest
    } = this.props;
    const inputProps = {
      value,
      onChange: this.onChange,
      ...rest
    };

    return (
      <Autosuggest
        className={`${classPrefix}__container ${className}`}
        multiSection={true}
        suggestions={suggestions}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion(classPrefix)}
        renderSectionTitle={renderSectionTitle}
        renderInputComponent={renderInputComponent}
        getSectionSuggestions={getSectionSuggestions}
        onSuggestionSelected={onSuggestionSelected}
        inputProps={inputProps}
        highlightFirstSuggestion={true}
        renderSuggestionsContainer={showPopularCategories ? renderSuggestionContainer : undefined}
        theme={makeTheme(classPrefix)}
        focusInputOnSuggestionClick={focusInputOnSuggestionClick}
        shouldRenderSuggestions={val => showPopularCategories || val}
      />
    );
  }
}
